import { useHistory } from "react-router";
import {
  BarraBlancaBody,
  BarraBlancaBoton,
  BarraBlancaBotonBlue,
  BarraBlancaBotonInvisible,
  BarraBlancaContainer,
} from "./localStyle";
import BarraFiltros from "../BarraFiltros/BarraFiltros";
import EtiquetaAzulBusqueda from "../EtiquetaAzulBusqueda/EtiquetaAzulBusqueda";

const BarraBlanca = ({
  title,
  etiquetaBusqueda,
  filtros,
  onChangeFiltro,
  onChangeFecha,
  showFiltros,
  onClickFiltros,
}) => {
  //#region --------- context ---------------
  //#endregion  ----- context ---------------
  //#region  ----------- constants ---------------
  const history = useHistory();
  //#endregion --------- constants ---------------
  //#region  ----------- funciones ---------------
  const onClick = () => {
    history.push(`/autocheckin`);
  };

  //#endregion --------- funciones ---------------
  //#region  ----------- useEffect ---------------
  //#endregion  -------- useEffect ---------------

  return (
    <BarraBlancaContainer>
      <BarraBlancaBoton onClick={onClick}>
        <span>Atrás</span>
      </BarraBlancaBoton>
      <BarraBlancaBody>
        <span className="BarraBlanca-title">{title}</span>
        {etiquetaBusqueda && (
          <div className="BarraBlanca-info-container">
            <div className="BarraBlanca-etiquetaAzulContainer">
              <EtiquetaAzulBusqueda />{" "}
            </div>
          </div>
        )}
      </BarraBlancaBody>
      {filtros ? (
        <>
          <BarraBlancaBotonBlue onClick={onClickFiltros}>
            <span>Filtros</span>
          </BarraBlancaBotonBlue>
          <BarraFiltros
            showFiltros={showFiltros}
            onClickVolver={onClickFiltros}
            onChangeFiltro={(dtoFiltro) => onChangeFiltro(dtoFiltro)}
            onChangeFecha={(fechaSeleccionada, dtoFiltros) =>
              onChangeFecha(fechaSeleccionada, dtoFiltros)
            }
          />
        </>
      ) : (
        <BarraBlancaBotonInvisible />
      )}
    </BarraBlancaContainer>
  );
};

export default BarraBlanca;
